import { createContext, useContext } from 'react';

export interface OpenPanelOptions {
  colnames: string[];
  title: string;
  anchor: { x: number; y: number };
}

export interface FieldHistoryContextValue {
  openPanel: (options: OpenPanelOptions) => void;
  /**
   * Current value of an order field by camelCase key. Supplied by the host
   * form so a menu item can act on the underlying value rather than the
   * label's display string — e.g. seeding the Table Maintenance search from
   * `chassisProvider` where the label shows "DCLI / STANDARD".
   */
  getFieldValue?: (fieldKey: string) => string;
}

export const FieldHistoryContext = createContext<FieldHistoryContextValue | null>(null);

export function useFieldHistory(): FieldHistoryContextValue | null {
  return useContext(FieldHistoryContext);
}
